export const DEFAULT_CONTENT_ALARM_MESSAGES_FIELDS = {
  news: ['time', 'title', 'relation.title', 'url'],
  instagram: ['time', 'title', 'url'],
  twitter: ['time', 'title', 'url'],
  telegram: ['time', 'title', 'url'],
  newspaper: ['time', 'title', 'url'],
  linkedin: ['time', 'title', 'url'],
  nativePlatforms: ['time', 'title', 'url'],
  bale: ['time', 'title', 'url'],
  rubika: ['time', 'title', 'url'],
  eitaa: ['time', 'title', 'url'],
  virasty: ['time', 'title', 'url'],
};

export const DEFAULT_REPORTING_ALARM_MESSAGES_FIELDS = {
  news: ['send_time', 'post_count', 'agency_count'],
  instagram: ['send_time', 'post_count', 'user_with_at_least_one_post_count'],
  twitter: ['send_time', 'post_count', 'user_with_at_least_one_post_count'],
  telegram: ['send_time', 'post_count', 'user_with_at_least_one_post_count'],
  virasty: ['send_time', 'post_count', 'user_with_at_least_one_post_count'],
};
